import FillMethod from './FillMethod'
import Logger from '../Log'
import { ecpmOrDefault, topmostWindowFrame } from '../utils'

const Log = Logger.for('NativoFillMethod')

export default class NativoFillMethod extends FillMethod {
  constructor (bidder) {
    super('nativo', bidder, 'native', ecpmOrDefault(bidder.params.ecpm, 2))
  }

  fill (slot, media) {
    return new Promise((resolve, reject) => {
      const frame = topmostWindowFrame()
      const div = frame.document.createElement('div')
      div.id = 'smrtb-nativo-' + this._bidder.params.ptd + '-' + (slot.instanceIdx() + 1)
      slot.node().appendChild(div)

      Log.debug('Running nativo fill method ' + this._bidder.params.ptd + ' with id ' + div.id)

      const ntv = frame.ntv
      if (!ntv) {
        Log.warn('No window.ntv for nativo! Aborting fill method')
        slot.resetNode()
        return resolve({ cpm: 0 })
      }

      let noad = false

      const to = setTimeout(() => {
        if (noad === true) return // already resolved

        if (div.childNodes.length > 0) {
          Log.debug('Nativo noad didnt fire and found div content, marking clear')
          resolve({
            cpm: this.estValue(),
            width: 1,
            height: 1
          })
          return
        }

        Log.warn('Nativo noad didnt fire but looks like we timed out waiting for an ad')
        slot.resetNode()
        noad = true
        resolve({ cpm: 0 })
      }, 2000)

      /*
      Note due to Nativos noad event there cannot be multiple instances of the same zone ID/ptd value firing at the exact
      same time, otherwise we cant differentiate them.
       */
      ntv.Events.PubSub.subscribe('noad', (e) => {
        for (const el of e.data) {
          // eslint-disable-next-line eqeqeq
          if (el.id == this._bidder.params.ptd) {
            Log.debug('Found Nativo noad event')
            if (noad === true) {
              Log.warn('NoAd event fired after we already timed out awaiting response!')
              resolve({ cpm: 0 })
              return
            }

            noad = true
            clearTimeout(to)
            slot.resetNode()

            resolve({ cpm: 0 })
            break
          }
        }
      })

      frame.PostRelease.Start({ ptd: [parseInt(this._bidder.params.ptd)] })
    })
  }
}
